import React from 'react';
import { NavLink } from 'react-router-dom';

const Foundation = (props) => (
    <div className="row justify-content-center">
        <div className="col-md-10">
            <h2 className="display-4 text-center">ФОНДАЦИЯТА</h2>
            <p className="text-justify">ФОНДАЦИЯ „ПАИСИАДА – ПРЕДАЙ НАТАТЪК!“ е учредена от български учени, за да изследва, съхрани и предаде нататък паметта за йеромонах Паисий проигумен Хилендарски и духовните му ученици – преписвачите на „История славянобългарска“ през XVIII и XIX век.</p>
            <p className="text-justify">Фондацията не подкрепя политически партии, синдикални дейности и религиозни каузи! Нашата задача е да разширим съвременната аудитория на „Паисиада“ и да подхраним куража на българите, които не се срамуват от българското, и могат достойно да го предадат нататък!</p>
            <p className="text-justify">Подкрепете и вие нашата кауза, за да предадем заедно на идната България духовните послания и ценности на Българската ръкописна възрожденска „Паисиада“!
            </p>
            <div className="text-center">
                <NavLink to="/fondation" className="btn btn-danger">Ето как:</NavLink>
            </div>
        </div>
    </div>
);

export default Foundation


// WEBPACK FOOTER //
// ./src/views/Home/foundation.block.jsx